import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import {
  CaseSelectControlName,
  getDefaultControlValue,
  RequestModeControlName,
} from '@gk/gk-modules';
import { ECSControlName } from '../../../../components/electronic-correspondence-statement/models/form/form.model';
import { BaseNewRequestFormService } from '../../../../shared/base-new-request-form/base-new-request-form.service';
import {
  TSRNNewRequestControlName,
  TSRNNewRequestFormGroup,
} from './new-request-form.model';

@Injectable()
export class TSRNNewRequestFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private baseNewRequestFormService: BaseNewRequestFormService,
  ) {}

  getFormGroup(): FormGroup<TSRNNewRequestFormGroup> {
    return this.formBuilder.group({
      ...this.baseNewRequestFormService.getCommonInvestorFormGroup(
        {
          [ECSControlName.ElectronicCorrespondenceStatement]: false,
          [RequestModeControlName.RequestMode]: true,
          [CaseSelectControlName.CaseUuid]: true,
        },
        {
          addressFormGroupBasedOnSelectControls: true,
          disableAddressFormInNaturalPersonGroup: true,
        },
      ).controls,
      [TSRNNewRequestControlName.OwnerOtherThanApplicant]:
        this.formBuilder.control(getDefaultControlValue()),
      [TSRNNewRequestControlName.Trees]: this.formBuilder.array([]),
      [TSRNNewRequestControlName.Shrubs]: this.formBuilder.array([]),
      [TSRNNewRequestControlName.NonBusinessPurposes]: this.formBuilder.control(
        getDefaultControlValue(),
        [Validators.required],
      ),
    });
  }
}
